module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x320-313b051b4467c05ce2ee7fc84495c1be.webp";